export default __webpack_public_path__ + "static/media/liber-t-v2.1e16885a.png";